import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { ButtonLink } from '../../../components';
import { t } from '../../../i18n';
import { formatCoursePrice } from '../../utilities';
import { cameraIcon, clockIcon, scribbleZigzagPriceImage } from '../../assets/index';
import UrlTo from '../../../url-to';
import PlayButton from '../play-button/index';
import getDiscountIconSrc from './getDiscountIconSrc';
import './styles.scss';

const CourseCard = ({ course, onPlayCoursePreview }) => (
  <div className="course-card">
    <div className="course-card__author-info">
      <img className="course-card__author-avatar" src={course.author.avatarImageUrl} alt="avatar" />
      <b title={course.author.fullName} className="course-card__author-name">
        {course.price.isDiscountApplied && (
          <div className="course-card__discount-icon">
            <img
              src={getDiscountIconSrc(course.price.discountPercentage)}
              alt={`Discount ${course.price.discountPercentage}%`}
            />
          </div>
        )}
        {course.author.fullName}
      </b>
    </div>
    <div className="course-card__thumbnail" onClick={() => onPlayCoursePreview(course.previewVideo)}>
      <picture>
        <source media="(min-width: 1000px)" srcSet={course.previewImageUrlLarge} />
        <img src={course.previewImageUrlSmall} alt={course.title} className="course-card__thumbnail-image" />
      </picture>
      <PlayButton />
    </div>
    <div
      className={classNames(
        'course-card__summary',
        course.price.isDiscountApplied && 'course-card__summary--discounted',
      )}
    >
      <div className="course-card__course-hours">
        <img src={clockIcon} alt="hours" />
        <span className="course-card__course-hours_full">{`${course.hoursTotal} ${t('DIGITAL_COURSES.HOURS')}`}</span>
        <span className="course-card__course-hours_short">{`${course.hoursTotal}${t(
          'DIGITAL_COURSES.HOURS_SHORT',
        )}`}</span>
      </div>
      {course.lessonsTotal > 1 && (
        <div className="course-card__course-lessons-number">
          <img src={cameraIcon} alt="lessons-number" />
          {`${course.lessonsTotal} ${t('DIGITAL_COURSES.LESSONS')}`}
        </div>
      )}
      <div className="course-card__course-price">
        <CoursePrice price={course.price} />
      </div>
    </div>
    <Link className="course-card__texts" to={UrlTo.coursesSpecificCourse(course.id)}>
      <b className="course-card__title">{course.title}</b>
      <p
        className={classNames(
          'course-card__description',
          course.lessonsTotal > 1 && course.price.isDiscountApplied && 'course-card__description--discounted',
        )}
        dangerouslySetInnerHTML={{ __html: course.description }}
      />
    </Link>
    <div className="course-card__navigation-buttons-row">
      <ButtonLink
        href={UrlTo.coursesSpecificCourse(course.id)}
        text={t('DIGITAL_COURSES.LEARN_MORE')}
        type="white"
        className="course-card__view-more-button"
      />
      <ButtonLink
        href={UrlTo.coursesCheckout(course.id)}
        text={t('DIGITAL_COURSES.SPECIFIC_COURSE_SCREEN.BUY_COURSE')}
        type="green"
        className="course-card__purchase-course-button"
      />
    </div>
  </div>
);

export default CourseCard;

const CoursePrice = ({ price }) => {
  if (!price.isDiscountApplied) {
    return formatCoursePrice(price);
  }

  return (
    <div className="course-card__course-price-discounted">
      <strong className="course-card__course-price-new">{formatCoursePrice(price)}</strong>
      <strong className="course-card__course-price-old">
        {formatCoursePrice({ amount: price.originalAmount, currency: price.currency })}
        <img src={scribbleZigzagPriceImage} alt="Old price" />
      </strong>
    </div>
  );
};
